var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.608,
    height: 34.608,
    viewBox: "0 0 34.608 34.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.608,
    height: 34.608,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Speaker_1",
    "data-name": "Speaker 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speaker_1-2",
    "data-name": "Speaker 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2403",
    "data-name": "Trac\\xE9 2403",
    d: "M20.478,6.086a1.076,1.076,0,0,1,.663.995V30.874a1.082,1.082,0,0,1-1.839.771l-6.33-6.215H9.244A3.245,3.245,0,0,1,6,22.186V15.718a3.24,3.24,0,0,1,3.244-3.244h3.728L19.3,6.309A1.066,1.066,0,0,1,20.478,6.086Zm-1.5,3.562-4.809,4.679a1.069,1.069,0,0,1-.757.31H9.244a1.08,1.08,0,0,0-1.081,1.081v6.467a1.085,1.085,0,0,0,1.081,1.081h4.167a1.057,1.057,0,0,1,.757.31l4.809,4.715ZM23.542,12.9a1.08,1.08,0,0,1,1.521-.173h.007v.007l.014.007.029.029a.936.936,0,0,1,.1.087c.079.072.187.173.31.3a7.389,7.389,0,0,1,.872,1.168,8.81,8.81,0,0,1,1.24,4.65,8.8,8.8,0,0,1-1.24,4.643,7.172,7.172,0,0,1-.872,1.175c-.123.13-.231.231-.31.3-.043.043-.087.079-.13.115l-.014.014h-.007s-.966.526-1.514-.166a1.076,1.076,0,0,1,.159-1.514l.007-.007-.007.007.007-.007h0a.26.26,0,0,1,.036-.029c.043-.036.1-.1.187-.187a5.46,5.46,0,0,0,.613-.822,6.7,6.7,0,0,0,.923-3.526,6.683,6.683,0,0,0-.923-3.526,5.46,5.46,0,0,0-.613-.822,1.919,1.919,0,0,0-.187-.18.162.162,0,0,0-.036-.036h0A1.078,1.078,0,0,1,23.542,12.9Zm.173,1.514h-.007Z",
    transform: "translate(-1.674 -1.674)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2404",
    "data-name": "Trac\\xE9 2404",
    d: "M0,0H34.608V34.608H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volumeIcon.3f8b0750ac107b78d6ad1d5efdad2971.svg";
export { ForwardRef as ReactComponent };